export const VIEW_ENTER = 'bettingBuddy/VIEW_ENTER';
export const SET_EVENTS_DAY = 'bettingBuddy/SET_EVENTS_DAY';
export const SET_MARKET_GROUP_ID = 'bettingBuddy/SET_MARKET_GROUP_ID';
export const SLIP_SELECTION_ADD = 'bettingBuddy/SLIP_SELECTION_ADD';
export const SLIP_SELECTION_REMOVE = 'bettingBuddy/SLIP_SELECTION_REMOVE';
export const SLIP_SELECTION_DESELECT = 'bettingBuddy/SLIP_SELECTION_DESELECT';
export const SLIP_CLEAR = 'bettingBuddy/SLIP_CLEAR';
export const SLIP_RESTORE = 'bettingBuddy/SLIP_RESTORE';
export const SLIP_NAME_CHANGED = 'bettingBuddy/SLIP_NAME_CHANGED';
export const SLIP_STAKE_CHANGED = 'bettingBuddy/SLIP_STAKE_CHANGED';
export const SAVE_SLIP_BUTTON_CLICKED = 'bettingBuddy/SAVE_SLIP_BUTTON_CLICKED';
export const SAVED_SLIPS_VIEW_ENTER = 'bettingBuddy/SAVED_SLIPS_VIEW_ENTER';
export const LOAD_SLIPS_SUCCESS = 'bettingBuddy/LOAD_SLIPS_SUCCESS';
export const LOAD_SLIPS_START = 'bettingBuddy/LOAD_SLIPS_START';
export const LOAD_SLIPS_FAILED = 'bettingBuddy/LOAD_SLIPS_FAILED';
export const SLIP_SAVE_PENDING = 'bettingBuddy/SLIP_SAVE_PENDING';
export const DELETE_SLIP = 'bettingBuddy/DELETE_SLIP';
export const SLIP_DELETE_CONFIRMED = 'bettingBuddy/SLIP_DELETE_CONFIRMED';
export const SLIP_DELETE_CANCELLED = 'bettingBuddy/SLIP_DELETE_CANCELLED';
export const SAVED_SLIPS_SHOW = 'bettingBuddy/SAVED_SLIPS_SHOW';
export const SAVED_SLIPS_HIDE = 'bettingBuddy/SAVED_SLIPS_HIDE';
export const SLIP_SHOW = 'bettingBuddy/SLIP_SHOW';
export const SLIP_HIDE = 'bettingBuddy/SLIP_HIDE';
export const SLIP_SAVED = 'bettingBuddy/SLIP_SAVED';

export const viewEnter = () => ({
  type: VIEW_ENTER
});

export const setEventsDay = day => ({
  type: SET_EVENTS_DAY,
  day
});

export const setMarketGroupId = marketGroupId => ({
  type: SET_MARKET_GROUP_ID,
  marketGroupId
});

export const slipSelectionAdd = selection => ({
  type: SLIP_SELECTION_ADD,
  selection
});

export const slipSelectionRemove = selectionId => ({
  type: SLIP_SELECTION_REMOVE,
  selectionId
});

export const slipSelectionDeselect = selection => ({
  type: SLIP_SELECTION_DESELECT,
  selection
});

export const slipSelectionClick = (selection, selected) => (
  selected ? slipSelectionDeselect(selection) : slipSelectionAdd(selection)
);

export const slipClear = () => ({
  type: SLIP_CLEAR
});

export const slipRestore = (slip) => ({
  type: SLIP_RESTORE,
  slip
});

export const slipNameChanged = e => ({
  type: SLIP_NAME_CHANGED,
  name: e.target.value
});

export const slipStakeChanged = e => ({
  type: SLIP_STAKE_CHANGED,
  stake: e.target.value
});

export const saveSlipButtonClicked = () => ({
  type: SAVE_SLIP_BUTTON_CLICKED
});

export const savedSlipViewEnter = () => ({
  type: SAVED_SLIPS_VIEW_ENTER
});

export const loadSlipsSuccess = (slips) => ({
  type: LOAD_SLIPS_SUCCESS,
  slips
});

export const loadSlipsFailed = () => ({
  type: LOAD_SLIPS_FAILED
});

export const loadSlipsStart = () => ({
  type: LOAD_SLIPS_START
});

export const slipSavePending = isPending => ({
  type: SLIP_SAVE_PENDING,
  isPending
});

export const deleteSlip = slipId => ({
  type: DELETE_SLIP,
  slipId
});

export const slipDeleteConfirmed = () => ({
  type: SLIP_DELETE_CONFIRMED
});

export const slipDeleteCancelled = () => ({
  type: SLIP_DELETE_CANCELLED
});

export const savedSlipsShow = () => ({
  type: SAVED_SLIPS_SHOW
});

export const savedSlipsHide = () => ({
  type: SAVED_SLIPS_HIDE
});

export const slipShow = () => ({
  type: SLIP_SHOW
});

export const slipHide = () => ({
  type: SLIP_HIDE
});

export const slipSaved = () => ({
  type: SLIP_SAVED
});
